
export const StatisticsSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-10">
          <h2 className="text-3xl font-bold mb-4 text-emergency-700">The Reality of Emergency Preparedness</h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="bg-emergency-50 p-8 rounded-xl text-center">
            <h3 className="text-4xl font-bold text-emergency-600 mb-2">60%</h3>
            <p className="text-muted-foreground">of people have no emergency plan in place for disasters</p>
            <div className="text-xs text-emergency-600 mt-3">Source: FEMA</div>
          </div>
          
          <div className="bg-emergency-50 p-8 rounded-xl text-center">
            <h3 className="text-4xl font-bold text-emergency-600 mb-2">78%</h3>
            <p className="text-muted-foreground">more likely to recover quickly from disasters with an emergency plan</p>
            <div className="text-xs text-emergency-600 mt-3">Source: Red Cross</div>
          </div>
          
          <div className="bg-emergency-50 p-8 rounded-xl text-center">
            <h3 className="text-4xl font-bold text-emergency-600 mb-2">$6</h3>
            <p className="text-muted-foreground">saved in recovery costs for every $1 invested in disaster preparedness</p>
            <div className="text-xs text-emergency-600 mt-3">Source: National Institute of Building Sciences</div>
          </div>
          
          <div className="bg-emergency-50 p-8 rounded-xl text-center">
            <h3 className="text-4xl font-bold text-emergency-600 mb-2">44%</h3>
            <p className="text-muted-foreground">of businesses that experience a disaster never reopen</p>
            <div className="text-xs text-emergency-600 mt-3">Source: FEMA</div>
          </div>
        </div>
      </div>
    </section>
  );
};
